export default "__VITE_ASSET__bOjrcu4n__"